import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_team_management-share_button-view';
/**
 * Share button view in retailer
 */
export function trackRetailerTeamManagementShareButtonView(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken },
    });
}
